import React from 'react';
import { withRouter } from 'react-router-dom';

import Link from '../../shared/components/hyperlink';
import { Helpers } from '../../core/src/helpers';

import { Grid, Column } from '../../ui/components/grid';

import '../sale-page-tabs.less';

class SalePageTabs extends React.Component {
	constructor(props) {
		super(props);
		this.tabs = [];
	}

	tabClick(tab) {
		const { history } = this.props;
		let location = {pathname: tab.path};
		let { _preview } = (tab.search || {});
		if(tab.tabLink) {
			return;
		}
		if(_preview){
			location.search = '?' + Helpers.paramsToString({_preview});
		}

		tab.path && history.push(location);
		tab.onTabClick && tab.onTabClick();
	}

	handleKeyup = (e, index, tab) => {
		e.preventDefault();
		let charCode = e.keyCode || e.which;

		if (charCode === 37) {
			//when left arrow key is pressed
			this.setTabFocus(index - 1);
		} else if (charCode === 39) {
			//when right arrow key is pressed
			this.setTabFocus(index + 1);
        }
        if (charCode === 13) {
            this.tabClick(tab);
        }
	}

	setTabFocus = (index) => {
		if (index >= 0 && index < this.props.tabs.length) {
			this.tabs[index].focus()
		}
	}

	renderTabs() {
		const { tabs, selectedTab } = this.props;
		return (
			tabs.map((tab, index) => {
				//if no tabLink use frafment isntead of link component
				let WrapperComponent = React.Fragment;
				let wrappProps = {};
				const activated = tab.identifier === selectedTab ? 'activated' : '';
				if(tab.tabLink){
					wrappProps.to = tab.tabLink;
					WrapperComponent = Link;
				}
				return (
					<Column columnClass={`${activated ? " active" : ''}`} desktop={1} small={2} mobile={2}>
                        <WrapperComponent {...wrappProps}>
                            <div className='tabs-link'
                                onKeyUp={(e) => this.handleKeyup(e,index,tab)} 
                                tabIndex={activated ? 0 : -1} 
                                id={`tab_${index}`}
                                key={index}
                                ref={tabRef => this.tabs[index] = tabRef}
                                onClick={() => this.tabClick(tab)}
                                aria-label={tab.name}
                            >
								<p className='tab-title'>{tab.name}</p>
							</div>
						</WrapperComponent>
                    </Column>
				);
			})
		);
	}

	render() {
		const { tabs } = this.props;

        if(tabs.length < 2) return <div className="header-wrapper" />;

		return (
            <div className='sale-page-tabs-nav'>
                <Grid>{this.renderTabs()}</Grid>
            </div>
        );
	}
}

export default withRouter(SalePageTabs);